/* globals jQuery */
(function ($, conf) {
    'use strict';

    var DOM = {
            HEADER_ID: 'main_header',
            HEADER_OPEN_CLASS: 'isOpen',
            TOGGLE_MENU_ID: 'toggle_menu',
            USER_LOGIN: 'user_login',
            USER_MENU_BTN_ID: 'header_user_menu_btn',
            MENU: '.menu',
            MENU_SIDEBAR: '.menu-sidebar'
        },
        URL = {
            CURRENT_USER: '/profile/get_header_user_box'
        },
        maxMobileWidth = 768,
        $toggleMenu = document.getElementById(DOM.TOGGLE_MENU_ID),
        $header, prevScroll, isMobile;

    if ($toggleMenu) {
        $header = document.getElementById(DOM.HEADER_ID);
        initHeaderUI();
        getUserHeaderBox().then(updateHeaderUserContent);
    }
    /**
     * Dropdown menu
     */
    isMobile = (window.innerWidth < maxMobileWidth);
    if (isMobile) {
        document.querySelectorAll('[data-toggle~=dropdown]').forEach(setupDropdown);
    }

    /**
     * Dropdown menu setup
     */
    function setupDropdown(dropdownToggle) {
        dropdownToggle.setAttribute('aria-haspopup', 'true');
        dropdownToggle.setAttribute('aria-expanded', 'false');

        // eslint-disable-next-line vars-on-top
        var dropdownMenu = dropdownToggle.parentNode.querySelector('.dropdown-menu'),
            upicon = dropdownToggle.querySelector('.icon-arrow-up-3'),
            downicon = dropdownToggle.querySelector('.icon-arrow-down-3');

        dropdownMenu.setAttribute('aria-hidden', 'true');

        dropdownToggle.onclick = toggleDropdown;
        /**
         * Toggle dropdown menu
         */
        function toggleDropdown() {
            if (dropdownToggle.getAttribute('aria-expanded') === 'true') {
                dropdownToggle.setAttribute('aria-expanded', 'false');
                dropdownMenu.setAttribute('aria-hidden', 'true');
                dropdownMenu.style.display = 'none';
                downicon.style.display = 'inline-block';
                upicon.style.display = 'none';
                return;
            }
            dropdownToggle.setAttribute('aria-expanded', 'true');
            dropdownMenu.setAttribute('aria-hidden', 'false');
            dropdownMenu.style.display = 'block';
            downicon.style.display = 'none';
            upicon.style.display = 'inline-block';
            dropdownMenu.children[0].focus();
        }
    }

    /**
     * Initialize header behaviour
     */
    function initHeaderUI() {
        $toggleMenu.addEventListener('click', toggleSideMenu);
    }

    /**
     * Toggle mobile side menu
     * @param {Object} event
     */
    function toggleSideMenu(event) {
        event.preventDefault();

        $header.classList.toggle(DOM.HEADER_OPEN_CLASS);

        if (isMobile) {
            controlPageScroll();
        }

    }

    /**
     * Control page scroll
     */
    function controlPageScroll() {
        if ($header.classList.contains(DOM.HEADER_OPEN_CLASS)) {
            fixPage();
        } else {
            unFixPage();
        }
    }

    /**
     * Fix scroll page
     */
    function fixPage() {
        prevScroll = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
    }

    /**
     * Unfix scroll page
     */
    function unFixPage() {
        document.body.style.position = 'initial';
        document.body.style.width = 'initial';
        window.scrollTo(0, prevScroll);
    }

    /**
     * Get user header box
     * @return {Promise}
     */
    function getUserHeaderBox() {
        return $.get(URL.CURRENT_USER)
            .done(function getCurrentUser(response) {
                return (response.content !== null) ? Promise.resolve(response.content) : Promise.resolve(null);
            });
    }

    /**
     * Update header with user content
     * @param {Object} response
     */
    function updateHeaderUserContent(response) {
        var $userLogin = document.getElementById(DOM.USER_LOGIN),
            $userMenuSidebar = document.querySelector(DOM.MENU_SIDEBAR);

        if (response.content === null) { return; }
        $userLogin.innerHTML = response.content;

        if ($userMenuSidebar && conf.isMobile) {
            initHeaderUserMenuBtn();
        }
    }

    /**
     * Initialize user menu header button in mobile
     */
    function initHeaderUserMenuBtn() {
        document.getElementById(DOM.USER_MENU_BTN_ID).addEventListener('click', onClickUserMenuBtn);
    }

    /**
     * On click user menu button, it should open user_menu sidebar menu
     * @param {Object} event
     */
    function onClickUserMenuBtn(event) {
        event.preventDefault();

        $header.classList.remove(DOM.HEADER_OPEN_CLASS);
        document.querySelector(DOM.MENU_SIDEBAR).classList.toggle('open');
        document.querySelector(DOM.MENU).classList.toggle('overlayed');

        controlPageScroll();
    }

}(jQuery, window.Namespace.configurations));
